export default {
  production:
    process.env.NODE_ENV === 'production' &&
    process.env.VUE_APP_PREVIEW !== 'true',

  devPort: parseInt(process.env.VUE_APP_DevPort), // 本地开发启动端口
  appId: process.env.VUE_APP_AppId,
  appSecret: process.env.VUE_APP_AppSecret,
}
